import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26d3d2eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "contentLeft",
  id: "contentLeft"
}
const _hoisted_2 = { class: "article" }
const _hoisted_3 = {
  class: "aiticleDate",
  id: "articleDetail"
}
const _hoisted_4 = { class: "articleMonth" }
const _hoisted_5 = { class: "articleDay" }
const _hoisted_6 = { class: "articleContent" }
const _hoisted_7 = { class: "article-header" }
const _hoisted_8 = { class: "article-title" }
const _hoisted_9 = { class: "article-meta" }
const _hoisted_10 = { class: "article-meta-date" }
const _hoisted_11 = { class: "article-meta-visitors" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "・", -1))
const _hoisted_13 = { class: "articleDetailBody" }
const _hoisted_14 = { class: "articleOption" }
const _hoisted_15 = { class: "leftOption" }
const _hoisted_16 = {
  key: 0,
  class: "rightOption"
}

import VContent from "@/components/editCompoents/VContent.vue";
import { Back, Edit, Delete, Remove } from "@element-plus/icons-vue";
import { WarningFilled, QuestionFilled } from "@element-plus/icons-vue";
import { postSingleArticle } from "@/api/functions/home";
import { onMounted, ref, reactive, inject, watch } from "vue";
import { useRoute } from "vue-router";
import { initArticleResults } from "@/api/apitypes/response/ArticleResponse";
import { parseTime } from "@/functions/utils/DateUtils";
import {
  ArticleSearchRequest,
  initArticleSearchRequest,
} from "@/api/apitypes/request/ArticleSearchRequest";
import Waline from "@/components/homeComponents/Waline.vue";
import { postDelete, postHide } from "@/api/functions/home";
import { ElMessage } from "element-plus";
import { reloadKey } from "@/functions/keys/index";
import { reloadFunction } from "@/functions/utils/CommonUtils";


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailContent',
  setup(__props) {

const dialogVisible = reactive({
  visible: false,
});

const state = reactive({
  article: initArticleResults(),
});

const reload = inject(reloadKey) as reloadFunction;

const route = useRoute();

const loginStatus = ref(localStorage.getItem("token") != null);

const articleSearchRequest: ArticleSearchRequest = initArticleSearchRequest();

const showWaline = ref(false);

const getSingleArticle = async () => {
  articleSearchRequest.theme = route.params.theme as string;
  await postSingleArticle(articleSearchRequest).then((res) => {
    state.article = res.data;
    if (!res.data) {
      backHandle();
    } else {
      showWaline.value = true;
    }
  });
};

const backHandle = () => {
  history.back();
};

const deleteHandle = async () => {
  articleSearchRequest.uuid = state.article.uuid;
  articleSearchRequest.deleteFlag = state.article.deleteFlag;
  await postDelete(articleSearchRequest).then((res) => {
    ElMessage({
      message: "Congrats, Aiticle deleted",
      showClose: true,
      type: "success",
    });
    reload();
  });
};

const hideHandle = async () => {
  articleSearchRequest.uuid = state.article.uuid;
  articleSearchRequest.draftFlag = state.article.draftFlag;
  await postHide(articleSearchRequest).then((res) => {
    ElMessage({
      message: "Congrats, Aiticle hided",
      showClose: true,
      type: "success",
    });
    reload();
  });
};

onMounted( async ()  => {
  await getSingleArticle();
  var scrollDom = document.getElementById("contentLeft") as HTMLElement;
  window.scrollTo({
    top: scrollDom.getBoundingClientRect().top,
    behavior: "smooth",
  });
});

watch(route, () => {
  getSingleArticle();
  reload();
});

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_AlarmClock = _resolveComponent("AlarmClock")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_View = _resolveComponent("View")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("article", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(parseTime)(state.article.createTime, "{m}")) + "月 ", 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(parseTime)(state.article.createTime, "{d}")), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("header", _hoisted_7, [
          _createElementVNode("h1", _hoisted_8, [
            (state.article.deleteFlag)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  effect: "dark",
                  round: "",
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 已删除 ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(state.article.title), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_AlarmClock)
                ]),
                _: 1
              }),
              _createTextVNode("  "),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("menus.home.createTime")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(_unref(parseTime)(state.article.createTime, "{y}-{m}-{d}")), 1)
            ]),
            _createElementVNode("span", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_View)
                ]),
                _: 1
              }),
              _createElementVNode("span", null, "  " + _toDisplayString(state.article.visits), 1),
              _createElementVNode("span", null, " " + _toDisplayString(_ctx.$t("menus.home.visitsCount")), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(VContent, {
            content: state.article.content
          }, null, 8, ["content"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_el_tooltip, {
              content: "Return",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  icon: _unref(Back),
                  round: "",
                  onClick: backHandle
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("menus.home.return")), 1)
                  ]),
                  _: 1
                }, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          (loginStatus.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_el_space, {
                  size: 10,
                  wrap: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tooltip, {
                      content: "Edit",
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: {
                    name: 'edit',
                    params: { theme: state.article.theme },
                  }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "success",
                              icon: _unref(Edit),
                              circle: ""
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_popconfirm, {
                      width: "220",
                      "confirm-button-text": "Yes",
                      "cancel-button-text": "No",
                      icon: _unref(WarningFilled),
                      "icon-color": "#626AEF",
                      title: "Are you sure to delete?",
                      onConfirm: deleteHandle
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "danger",
                          icon: _unref(Delete),
                          circle: ""
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_popconfirm, {
                      width: "220",
                      "confirm-button-text": "Yes",
                      "cancel-button-text": "No",
                      icon: _unref(QuestionFilled),
                      "icon-color": "#626AEF",
                      title: "Are you sure to hide?",
                      onConfirm: hideHandle
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "info",
                          icon: _unref(Remove),
                          circle: ""
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_el_divider),
        (showWaline.value)
          ? (_openBlock(), _createBlock(Waline, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})